import TelegramIcon from '@mui/icons-material/Telegram';
import { Stack, Typography } from '@mui/material';
import { t } from 'i18next';
import React, { FC } from 'react';
import { Link } from 'react-router-dom';

import { APP_CONFIG } from '../config';

interface TelegramLoginButtonProps {
  onClickCallback: () => void;
}

const TelegramLoginButton: FC<TelegramLoginButtonProps> = ({
  onClickCallback,
}) => {
  return (
    <Link
      to={`tg://resolve?domain=${APP_CONFIG.TELEGRAM_AUTH_BOT_USERNAME}&start=login`}
      target="_blank"
      style={{
        display: 'inline-block',
        textDecoration: 'none',
      }}
    >
      <Stack
        direction="row"
        alignItems="center"
        gap="12px"
        sx={{
          width: '288px',
          padding: '14px 30px',
          backgroundColor: 'blue.2',
          borderRadius: '8px',
          textDecoration: 'none',
          textAlign: 'center',
        }}
        onClick={onClickCallback}
      >
        <TelegramIcon
          sx={{
            color: 'grey.1',
            fontSize: '28px',
          }}
        />
        <Typography
          sx={{
            color: 'grey.1',
            fontSize: '18px',
            fontWeight: 600,
          }}
        >
          {t('login.button')}
        </Typography>
      </Stack>
    </Link>
  );
};

export default TelegramLoginButton;
